import React, { Component } from "react";
import { DropdownButton, MenuItem,OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon }        from '@fortawesome/react-fontawesome'
import uniqueId from 'lodash/uniqueId';
import Sortable from 'react-sortablejs';
import groupBy  from 'lodash/groupBy';
import { ExerciseFreeFormId }   from "../../utils/StaticIds";
import { faCircle }              from '@fortawesome/free-regular-svg-icons'

export default class SortableMonthViewExerciseList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            block_data: [],
            ex_names: null
        }

        this.editMonthViewExercise   = this.editMonthViewExercise.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        var items_arr = [];

        this.setState({
            block_data: nextProps.block_data,
            ex_names:   nextProps.ex_names
        })
    }

    /*openExerciseDetailModal () {
        console.log("openExerciseDetailModal");
    }*/

    editMonthViewExercise = (day_id, block_index, block_id, set_id, ex_id, ex_order, ex_name) => {
        console.log("1. >>>>>>> ex_order: " + ex_order);
        this.props.editMonthViewExercise(day_id, block_index, block_id, set_id, ex_id, ex_order, ex_name)
    }

    renderExerciseRows(block_index, week_id, day_id, block_id, block_ids, ex_names, ex_ids, ex_orders, ex_notes, set_ids) {
        var lgth = block_ids.length;
        var exercise_row;
        var that = this;


        exercise_row = Object.keys(ex_names).map( index => {
            var tmp_block_id = block_ids[index];
            var set_id    = set_ids[index];
            var ex_name   = ex_names[index];
            var ex_id     = ex_ids[index];
            var ex_order  = ex_orders[index]; // don't use index as order; the index continues after every block
            var ex_note   = ex_notes[index];

            if(block_id === tmp_block_id) {

                return  <div key={uniqueId()}
                             data-id  = {set_id}
                             week_id  = {week_id}
                             day_id   = {day_id}
                             block_id = {block_id}
                             set_id   = {set_id}
                             ex_id    = {ex_id}
                             ex_name  = {ex_name}
                             ex_order = {ex_order}
                             notes    = {ex_note}

                             onClick  = { (e) => this.editMonthViewExercise(day_id, block_index, block_id, set_id, ex_id, ex_order, ex_name) }
                             style    = {{cursor: "pointer", padding:8, width:"99%", backgroundColor: "#fff"}}
                        >
                                {ex_name /*set_id*/ }
                                {/*}
                                <FontAwesomeIcon icon={faCircle}
                                                 style={{float:"left", width: "40px"}}
                                                 className = "createMonthViewDay_faCircl"/>
                                { /* }
                                <span className="weekMainSingleDayExerciseEditIcons3dots"
                                      onClick   = {(e) => {e.stopPropagation()}}>
                                        <DropdownButton bsSize    = "large"
                                                        pullRight
                                                        title     = "..."
                                                        className = "glyphicon glyphicon-option-horizonta pull-right weekMainSingleDayEditIcons3"
                                                        onClick   = {(e) => {e.stopPropagation()}}
                                                        style     = {{fontSize:45, border:0, backgroundColor: "#fff"}}
                                                        id        = "dropdown-size-large">
                                              <MenuItem className="dropdownMenuItem"
                                                          //onClick={(e) => {e.stopPropagation(); that.props.addNewDayFromMonthView()}}>
                                                          onClick={() => this.props.showDayModalSimple(true, 1, 2, 1233, "exercise_name", 4, 6, "rest", "notes", "modal_simple_action", 0, "youtube_id")}>
                                                  <span className = "glyphicon glyphicon-plus yellowColor"
                                                        //onClick={(e) => {e.stopPropagation(); that.props.addNewDayFromMonthView(week_id, total_week_days)}}
                                                  /> &nbsp;
                                                  Add Day
                                              </MenuItem>
                                              <MenuItem divider />
                                              <MenuItem className="dropdownMenuItem"
                                                          onClick={(e) => {e.stopPropagation(); that.props.duplicateDay()}}>
                                                  <span className = "glyphicon glyphicon-duplicate yellowColor"
                                                        //onClick={(e) => {e.stopPropagation(); that.props.addNewDayFromMonthView(week_id, total_week_days)}}
                                                  /> &nbsp;
                                                  Duplicate Day
                                              </MenuItem>
                                        </DropdownButton>
                              </span>*/ }
                        </div>
                }
        })

        //if(ex_names.length === 0)
        //    exercise_row = <div>Place an exercise here</div>

        return exercise_row
    }

    render() {
        let sortable = null; // sortable instance
        var that = this;

        var item_ctr     = this.props.item_ctr;
        var index        = this.props.index;
        var block_data   = this.props.block_data;
        var block_id     = this.props.block_id;
        var block_ids    = this.props.block_ids;
        var block_name   = this.props.block_name;
        var day_id       = this.props.day_id;
        var week_id      = this.props.week_id;
        var ex_names     = this.props.ex_names;
        var ex_ids       = this.props.ex_ids;
        var ex_orders    = this.props.ex_orders;
        var ex_notes     = this.props.ex_notes;
        var set_ids      = this.props.set_ids;
        var total_blocks = this.props.total_blocks;
        var listItems    = null;
        var show_add_exercise_icon = "inline"; // show or hide the "add exercise" icon
        //var block_title = "Block " + parseInt(item_ctr);

        ////  GET BLOCK NAME, if none, increment Block #  ////
        var res = block_name.split(" ");
        var res1    = res[1];
        var isBlock = res[0];
        var int = parseInt(res1);
        //// If the block title is "Block " + number, increment the block #  ////
        ////  OR if there is no block name at all, add an incremented block
        if(isBlock === "Block" && int != "NaN" || (isBlock == "" && res1 == undefined))
            block_name = "Block " + item_ctr;


        if(block_ids != undefined) {

            ////  CHECK IF THE BLOCK CONTAINS A FREE-FORM EXERCISE             ////
            ////  If so, then don't show the "add exercise" icon on the Block  ////
            Object.keys(ex_names).map( index => {
                var tmp_block_id = block_ids[index];
                if(block_id === tmp_block_id) {
                    var ex_id     = ex_ids[index];
                    if(ex_id === ExerciseFreeFormId) show_add_exercise_icon = "none"
                }
            })

            listItems = <div key={uniqueId()}
                                 className= {"h123Default exerciseNameOverflowEllipsis"}
                                 style      = {{border: "1 #000 solid"}}
                                 data-id    = {block_id }
                                 day_id     = {day_id}
                                 block_id   = {block_id}
                                 block_name = {block_name}
                                 week_id    = {week_id}
                            >
                                    <div style={{fontSize:20, overflowX:"hidden"}}
                                         block_id   = {block_id}
                                         block_name = {block_name}
                                         day_id     = {day_id}
                                         week_id    = {week_id}
                                    >
                                        <div style={{cursor: "pointer", width:"100%", padding:8, backgroundColor: "#dedede"}}>
                                            <div style={{width:"76%", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden"}}>
                                                <b> { block_name } { /*block_id*/ } </b>
                                            </div>
                                        </div>
                                        <OverlayTrigger placement = "top"
                                             overlay={<Tooltip id="top" style={{fontSize:16, borderTopColor: "transparent"}}>Add Exercise</Tooltip>}
                                        >
                                            <span className="glyphicon glyphicon-plus pull-right weekMainSingleDayBlockEditIcons1"
                                                  style={{display: show_add_exercise_icon}}
                                                                          // index, block_index, exercise_id, exercise_name, measure_2_id, measure_3_id, rest, notes, modal_simple_action, advanced_metrics, youtube_id)
                                                //onClick={() => that.props.showDayModalSimple(true /*showModalSimple*/, 1, 2, 0, "" /*exercise_name*/, 4, 6, 0 /*rest*/, "" /*note*/, "modal_simple_action", 0 /*advanced_metrics*/ , 0 /*youtube_id*/ )}
                                                onClick={() => that.props.openAddNewExerciseModal(index, day_id, block_id)}
                                            />
                                        </OverlayTrigger>

                                        <OverlayTrigger placement = "top"
                                             overlay={<Tooltip id="top" style={{fontSize:16, borderTopColor: "transparent"}}>Duplicate Block</Tooltip>}
                                        >
                                            <span className="glyphicon glyphicon-duplicate pull-right weekMainSingleDayBlockEditIcons2"
                                                onClick={() => that.props.duplicateBlock(index, week_id, day_id, block_id, total_blocks, block_name )}
                                            />
                                        </OverlayTrigger>

                                        <OverlayTrigger placement = "top"
                                             overlay={<Tooltip id="top" style={{fontSize:16, borderTopColor: "transparent"}}>Delete Block</Tooltip>}
                                        >
                                            <span className="glyphicon glyphicon-remove pull-right weekMainSingleDayBlockEditIcons3"
                                                onClick={() => that.props.deleteBlock(index, day_id, block_id)}
                                            />
                                        </OverlayTrigger>

                                        { /*/ }
                                        <span className="weekMainSingleDayBlockEditIcons1pos"
                                              style     = {{position:"absolute", top:20, left:100, zIndex: 15001}}
                                              onClick   = {(e) => {e.stopPropagation()}}>
                                                { /*<DropdownButton bsSize    = "large"
                                                                pullRight
                                                                /*onSelect={(event) => this.onSelect(event)} /
                                                                title     = "..."
                                                                className = "glyphicon glyphicon-option-horizonta pull-right weekMainSingleDayBlockEditIcons1"
                                                                onClick   = {(e) => {e.stopPropagation()}}
                                                                style     = {{fontSize:45, border:0, backgroundColor: "transparent"}}
                                                                id        = "dropdown-size-large">
                                                         <MenuItem className="dropdownMenuItem"
                                                                      onClick={(e) => {e.stopPropagation(); that.props.duplicateBlock(index, week_id, day_id, block_id, total_blocks )}}>
                                                              <span className = "glyphicon glyphicon-duplicate yellowColor"/> &nbsp;
                                                              Duplicate Block
                                                        </MenuItem>
                                                        <MenuItem divider />
                                                        <MenuItem className="dropdownMenuItem"
                                                                  onClick={(e) => {e.stopPropagation(); that.props.deleteBlock(block_id)}}>
                                                          <span className = "glyphicon glyphicon-remove yellowColor"/> &nbsp;
                                                          Delete Block
                                                      </MenuItem>
                                                </DropdownButton>
                                      </span>
                                      { /* }*/ }
                                        <Sortable
                                            className="trackBlockContainer"

                                            options={{
                                                group: "exercises",
                                                sort: true,
                                                //disabled: true,
                                    			animation: 150,
                                                // not useable: onStart: (evt) => { },
                                                /*onChoose: (evt) => {
                                                    var tmp_set_id = set_ids[evt.oldIndex];
                                                    this.props.editMonthViewExercise(tmp_set_id);
                                            	},*/
                                                onEnd: (evt) => {
                                                    //console.log("+++++++++++++++   ON BLOCK MONTHVIEW END   ++++++++++++++++");
                                                    var itemEl = evt.item;   // dragged HTMLElement
                                                    var evt_to = evt.to;     // not useable
                                                    var evt_from = evt.from; // not useable
                                                    // gives incorrect values (don't use): var evt_old_index = evt.oldIndex;  // element's old index within old parent
                                                    // gives incorrect values (don't use):var evt_new_index = evt.newIndex;  // element's new index within new parent

                                                    /*var list = document.getElementsByClassName("programs");//"trackBlockBox");
                                                    // Root Hierarchy: programs > monthViewWeek > monthViewDay > monthViewDayBlocks >
                                                    //                  monthViewDayBlockList
                                                    console.log("List: " +   list.length);
                                                    var blocks_order_arr        = [];
                                                    var blocks_exercs_order_arr = [];
                                                    /*for (var i = 0; i < list.length; i++) {
                                                        console.log(list[i]);
                                                        var child_lgth = list[i].children.length;
                                                        for (var j = 0; j < child_lgth; j++) {
                                                            var tmp_block_id = list[i].children[j].attributes.getNamedItem("block_id").value;
                                                            blocks_order_arr.push(tmp_block_id);

                                                            //console.log(j + ". Block id: " + tmp_block_id);
                                                        }
                                                    }*/

                                                    /*for (var i = 0; i < list.length; i++) {
                                                        var child_lgth = list[i].children.length;
                                                        var tmp_week_id    = list[i].children[0].attributes.getNamedItem("week_id").value;
                                                        //var tmp_week_order = list[i].children[0].attributes.getNamedItem("week_order").value;
                                                        var tmp_day_id     = list[i].children[0].attributes.getNamedItem("day_id").value;
                                                        var tmp_block_id   = list[i].children[0].attributes.getNamedItem("block_id").value;

                                                        var exercise_order_arr      = []; // reset array
                                                        for (var j = 0; j < child_lgth; j++) {
                                                            var tmp_set_id   = list[i].children[j].attributes.getNamedItem("set_id").value;
                                                            var tmp_ex_name  = list[i].children[j].attributes.getNamedItem("ex_name").value;

                                                            blocks_order_arr.push(tmp_block_id);
                                                            exercise_order_arr.push(tmp_set_id);
                                                        }
                                                        if(child_lgth > 0)
                                                            blocks_exercs_order_arr.push([tmp_week_id, tmp_day_id, tmp_block_id, exercise_order_arr])
                                                    }*/

                                                    var last_exercise_in_block = false;
                                                    var exercise_id_from;
                                                    var exercise_id_to;

                                                    var child_node     = evt.from.children[0];
                                                    var child_node2    = evt.to.children[0];

                                                    //console.log("child_node2: " + child_node2);

                                                    var exercise_id_to;
                                                    //
                                                    if (child_node2 != undefined)
                                                        exercise_id_to = child_node2.attributes.getNamedItem("ex_id").value;

                                                    if (child_node != undefined)
                                                        exercise_id_from = child_node.attributes.getNamedItem("ex_id").value;

                                                    /*if(evt.from.children[0] != undefined && block_id != null) {} else */
                                                    // Can't move a Free-form exercise to another block                            //
                                                    // If an exercise does get removed from a block and there are no other         //
                                                    // exercises in it, there will be massive duplication of the exercises in the  //
                                                    // block the exercise was dragged into; it cause big problems in the database  //
                                                    if (child_node === undefined || child_node2 === undefined || ExerciseFreeFormId === exercise_id_from)
                                                        last_exercise_in_block = true

                                                    var error_code = 4; // ie "Sorry, you can't move the last exercise in a block."
                                                    this.props.getProgramDOMTree(last_exercise_in_block, error_code);
                                                },
                                            }}

                                            //// Adding the below function REMOVES onEnd Sorting functionality
                                            /*onChange={(exercises_order, sortable, evt) => {}}/*/
                                        >
                                            {this.renderExerciseRows(index, week_id, day_id, block_id, block_ids, ex_names, ex_ids, ex_orders, ex_notes, set_ids) /*(tmp_block_arr[index][1], tmp_block_arr)*/ }
                                        </Sortable>

                                    </div>
                            </div>
        }

        return listItems;
    }
};

/*Sortable.propTypes = {
    items: React.PropTypes.array,
    onChange: React.PropTypes.func
};*/



// WEBPACK FOOTER //
// ./src/components/sortable/SortableMonthViewExerciseList.js